import { Grid, Row } from 'components/Layout/Grid';

import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: auto 0;

  @media only screen and (max-width: 1410px) {
    display: grid;
  }
`;

export const Title = styled.p`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.5rem;
  line-height: 3rem;

  text-align: center;

  color: #0E4C54;

  @media only screen and (max-width: 1300px) {
    font-size: 1.875rem;
  }

  @media only screen and (max-width: 1080px) {
    font-size: 1.563rem;
  }

  @media only screen and (max-width: 910px) {
    font-size: 1.25rem;
    line-height: 1.875rem;
  }
`;

export const Content = styled(Row).attrs({
  className: "justify-between"
})`

  margin-top: 1.563rem;

  @media only screen and (max-width: 1500px) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(90px, auto)); 
    gap: 50px;

    margin-top: 2.813rem;
  }

  @media only screen and (max-width: 1121px) {
    grid-template-columns: repeat(auto-fit, minmax(90px, auto)); 
    gap: 25px;
  }

  @media only screen and (max-width: 960px) {
    grid-template-columns: repeat(auto-fit, minmax(70px, auto)); 
    margin-top: 0rem;
    gap: 10px;
  }

  @media only screen and (max-width: 685px) {
    display: flex;
    grid-template-columns: none; 
    gap: 10px;
  }
`;

export const ContainerScore = styled(Grid).attrs({})`
  width: 120px;
  height: 195px;

  @media only screen and (max-width: 1200px) {
    width: 100px;
  }

  @media only screen and (max-width: 960px) {
    width: 80px;
  }

  @media only screen and (max-width: 960px) {
    width: 80px;
  }
`;

export const TextScore = styled.p`
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.25rem;
  line-height: 1.875rem;
  text-align: center;

  color: #7E8081;

  padding-top: 1.25rem;
 
  @media only screen and (max-width: 960px) {
    font-size: 1rem;
  }
`;